import { Box, Typography } from '@mui/material';
import { FC } from 'react';

interface LogoProps {

}

type Props = LogoProps;


const Logo: FC<Props> = (props: Props) => {

    return <Box sx={{ display: "flex", flexDirection: "column", color: "#20264a" }}>
        <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
                fontFamily: 'Indie Flower',
                fontWeight: 700,
                // letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
            }}
        >
            TIK TECH JOBS

        </Typography>
        <Typography variant="body2" component="a" href="/" sx={{ fontFamily: 'Indie Flower', color: 'inherit', textDecoration: 'none', fontWeight: 500 }}>
            Tailor made High Tech jobs!
        </Typography>
    </Box>;
}


export default Logo;

